<template>
    <fragment>

        <div class="form-group video-type-wrapper">
            <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" id="vimeo" :value="0" v-model="dataStore.typeOfVideo" class="custom-control-input" :checked="!dataStore.typeOfVideo">
                <label class="custom-control-label" for="vimeo">Vimeo</label>
            </div>
            <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" id="youtube" :value="1" v-model="dataStore.typeOfVideo" class="custom-control-input" :checked="dataStore.typeOfVideo">
                <label class="custom-control-label" for="youtube">Youtube</label>
            </div>
        </div>

        <div class="form-group">
            <label class="media-label">{{ language.add_type_media_legend }}</label>
            <input class="form-control" v-model="dataStore.activeVideoUrl" type="text" placeholder="Video-url"/>
        </div>

    </fragment>
</template>

<script>

import dataStore from "../../store";
import globalFunctions from "../../globalFunctions";
import { Fragment } from 'vue-fragment'

export default {

    data() {
        return {
            dataStore,
            globalFunctions,
        }
    },

    inject: [ 'language' ],

    components : {
        Fragment
    },

    methods: {

    }
};
</script>
